var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeviceVideoLtr = function SvgDeviceVideoLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 33a2 2 0 1 1 0-4 2 2 0 0 1 0 4m7.387 14.218a1 1 0 0 0 0-1.789l-13.764-6.882a1 1 0 0 0-1.447.895v13.764a1 1 0 0 0 1.447.894z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M80.21 22H21.79C19.15 22 17 24.185 17 26.866v36.268C17 65.815 19.15 68 21.79 68h58.42c2.64 0 4.79-2.185 4.79-4.866V26.866C85 24.185 82.85 22 80.21 22m-58.42 4.302h58.42c.3 0 .555.259.555.564v36.268a.567.567 0 0 1-.555.564H21.79a.567.567 0 0 1-.555-.564V26.866c0-.305.255-.564.555-.564",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95 74.5c0-1.38-1.034-2.5-2.31-2.5H9.247C8.001 72.038 7 73.143 7 74.5 7 75.88 8.035 77 9.31 77h83.442C93.999 76.962 95 75.857 95 74.5"
  })));
};
export default SvgDeviceVideoLtr;